import { ButtonComponentConfig, ButtonSize } from '../button';
import { IconType } from '../icon';

export const ToolbarBackButtonConfig: ButtonComponentConfig = {
  text: 'SHARED.BACK',
  size: ButtonSize.Small,
  icon: {
    name: 'arrow-left',
    type: IconType.NgZorro
  }
};
